import { useState } from "react";
import '../ReservationForm/reservationform.style.css';
import createReservation from "../../../../../utils/createReservation";

function ReservationForm() {
    const [name, setName] = useState('');
    const [cel, setCel] = useState(0);
    const [buyCoctel, setBuyCoctel] = useState('No');
    const [optionSelect, setOptionSelect] = useState('Mojito');
    const [cantPersons, setCantPersons] = useState('');
    const [dateEvent, setDateEvent] = useState('');
    const [cantHour, setCantHour] = useState('');
    const [msg, setMsg] = useState('');

    const setError = (containerMsg) => {
        setInterval(() => {
            containerMsg.removeAttribute('class', 'Message-Container');
            setMsg('');
        }, 5000)
    }

    const pushCoctels = () => {
        var arrayCoctels = [];
        const containerCoctelesArray = document.getElementById('Cocteles').childNodes;


        for (let i = 0; i < containerCoctelesArray.length; i++) {
            arrayCoctels.push(containerCoctelesArray[i].textContent);
        }

        return arrayCoctels;
    }

    const addReservation = (e) => {
        e.preventDefault();
        const coctels = pushCoctels();

        const reservation = {
            name,
            cel: parseInt(cel),
            licor: buyCoctel === 'Si' ? true : false,
            coctels,
            typeEvent: document.getElementById('typeE').value,
            cantPersons: parseInt(cantPersons),
            dateEvent,
            cantHours: parseInt(cantHour)
        }

        const newR = createReservation(reservation);

        console.log(newR);
        e.target.reset();
        const containerMsg = document.getElementById('Msg');
        containerMsg.setAttribute('class', 'Message-Success');
        setMsg('Se envío tu reservación con Éxito');
        setError(containerMsg);
    }

    const addCoctel = (e) => {
        e.preventDefault();

        const containerCoctelesArray = document.getElementById('Cocteles').childNodes;

        if (containerCoctelesArray.length === 4) {
            const containerMsg = document.getElementById('Msg');
            containerMsg.setAttribute('class', 'Message-Container');
            setMsg('Solo se permiten hasta 4 Cocteles');
            setError(containerMsg);
        } else {
            const containerCocteles = document.getElementById('Cocteles');

            const span = document.createElement('span');
            span.textContent = optionSelect;
            containerCocteles.appendChild(span);
        }
    }

    return (
        <section className="Reservation-Form-Component">
            <div className="Reservation-Form-Component__Container">
                <h2>Haz tu Cotización</h2>
                <p>
                    Reserva de acuerdo a lo que necesites y recibiras tu presupuesto en tu correo o WhatsApp
                </p>
                <div className="Reservation-Form-Component__Form">
                    <form onSubmit={addReservation}>

                        <div className="Input-Name__Input-Celphone__Container">
                            <div className="Input-Name">
                                <span>Nombre Completo</span>
                                <div className="Container-Name">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                        <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z" />
                                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                    </svg>
                                    <input onChange={(e) => setName(e.target.value)} type="text" placeholder="Ingrese Nombre Completo" required />
                                </div>
                            </div>

                            <div className="Input-Celphone">
                                <span>Celular</span>
                                <div className="Container-Celphone">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-plus" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                        <path fill-rule="evenodd" d="M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z" />
                                    </svg>
                                    <input onChange={(e) => { setCel(e.target.value) }} type="number" placeholder="Numero de Telefono" required />
                                </div>
                            </div>
                        </div>

                        <div className="Input-Licor">
                            <span>¿Pondras el Licor?</span>
                            <div className="Container-Licor">
                                <div className="Licor-Option">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" fill="currentColor" viewBox="0 -960 960 960" width="24"><path d="M160-120v-40h66.923v-139.538Q195-306.923 177.5-329.731 160-352.539 160-383.077V-660h173.846v276.923q0 29-17.884 52.577-17.885 23.577-49.039 30.962V-160h66.923v40H160Zm40-362.308h93.846V-620H200v137.692Zm46.923 146.154q19.308 0 33.115-13.808 13.808-13.807 13.808-33.115v-59.231H200v59.231q0 19.308 13.808 33.115 13.807 13.808 33.115 13.808Zm270 216.154q-16.5 0-28.25-11.75T476.923-160v-387.385q0-12.865 8.077-23.009 8.077-10.145 19.769-14.529l38-14.77q26.308-9.615 41-25.269 14.692-15.653 14.692-51.192v-132.937q0-13.294 8.846-22.102Q616.154-840 629.231-840h58.462q13.076 0 21.923 8.846 8.846 8.846 8.846 21.923v133.077q0 35.539 15.077 51.192 15.077 15.654 41.384 25.269l38.769 14.77q11.693 4.445 19.001 14.571Q840-560.227 840-547.385V-160q0 16.5-11.75 28.25T800-120H516.923Zm121.539-636.154h40V-800h-40v43.846Zm-121.539 300H800v-91.231l-38.769-14.769q-38-14-60.385-39-22.384-25-22.384-74.538v-40.462h-40v40.462q0 49.538-22.385 74.538t-60.385 39l-38.769 14.769v91.231Zm0 296.154H800v-107.692H516.923V-160Zm0-147.692H800v-108.462H516.923v108.462Zm-270-134.616Zm270 134.616v-108.462 108.462Z" /></svg>
                                    <select onChange={(e) => setBuyCoctel(e.target.value)}>
                                        <option value={'No'} selected>No</option>
                                        <option value={'Si'}>Si</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="Input-TypeEvent__Input-CantPerson__Container">
                            <div className="Input-TypeEvent">
                                <span>Tu Evento</span>
                                <div className="Container-Select">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-border-style" viewBox="0 0 16 16">
                                        <path d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z" />
                                    </svg>
                                    <select id="typeE" required>
                                        <option value={'Boda'} selected>Boda</option>
                                        <option value={'Despedida de Soltero(a)'}>Despedida de Soltero(a)</option>
                                        <option value={'Pasar el rato'}>Pasar el rato</option>
                                    </select>
                                </div>
                            </div>

                            <div className="Input-CantPerson">
                                <span>Cantidad de Personas</span>
                                <div className="Container-Persons">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people" viewBox="0 0 16 16">
                                        <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
                                    </svg>
                                    <input onChange={(e) => setCantPersons(e.target.value)} type="number" placeholder="Ingresa Cantidad" required />
                                </div>
                            </div>
                        </div>

                        <div className="Input-Date__Input-HourServices__Container">
                            <div className="Input-Date">
                                <span>Fecha del Evento</span>
                                <div className="Input-Date-Content">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-event" viewBox="0 0 16 16">
                                        <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                    </svg>
                                    <input onChange={(e) => setDateEvent(e.target.value)} type="date" required />
                                </div>
                            </div>

                            <div className="Input-HourServices">
                                <span>Cantidad de Horas</span>
                                <div className="Container-Hours">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                                        <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                                    </svg>
                                    <input onChange={(e) => setCantHour(e.target.value)} type="number" placeholder="Horas de Servicios" required />
                                </div>
                            </div>
                        </div>

                        <div className="Input-Coctels">
                            <div className="Input-Coctels__SelectCoctels">
                                <span>Selecciona los Cocteles</span>
                                <select onChange={(e) => setOptionSelect(e.target.value)} required>
                                    <option value={'Mojito'} selected>Mojito</option>
                                    <option value={'Piña Colada'}>Piña Colada</option>
                                    <option value={'Margarita'}>Margarita</option>
                                    <option value={'Tommys Margarita'}>Tommys Margarita</option>
                                    <option value={'Dry Martini'}>Dry Martini</option>
                                    <option value={'Manhattan'}>Manhattan</option>
                                    <option value={'Bloody Mary'}>Bloody Mary</option>
                                    <option value={'Tom Collins'}>Tom Collins</option>
                                    <option value={'Negroni'}>Negroni</option>
                                    <option value={'Daiquiri'}>Daiquiri</option>
                                </select>
                                <button className="Btn-AddCoctel" onClick={addCoctel}>Adicionar Coctel <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-patch-plus-fill" viewBox="0 0 16 16">
                                    <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z" />
                                </svg></button>
                            </div>
                            <div className="Input-Coctels__Container-Coctels">
                                <div id="Cocteles" className="Coctels">

                                </div>
                            </div>
                        </div>
                        <div id="Msg" className="Container-Msg">
                            <span> {msg} </span>
                        </div>
                        <button>Enviar Reservacion</button>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default ReservationForm;